/**
 * APIReadyState
 */
export enum FetchStatus {
  UNSET,
  LOADING,
  DONE,
  FAILED,
}
